import { MSG_REQUIRED } from "../../../../../../../helpers/validator-helper";
import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  value: Yup.string().required(MSG_REQUIRED),
  description: Yup.string().required(MSG_REQUIRED)
});
